import { SearchRounded } from '@mui/icons-material';
import { InputAdornment, SxProps, TextField } from '@mui/material';

export interface TextFieldFilterProps {
  placeholder?: string;
  value: string;
  onChange(value: string): void;
  sx?: SxProps;
}

export function TextFieldFilter({
  placeholder,
  value,
  onChange,
}: TextFieldFilterProps) {
  return (
    <TextField
      type="text"
      sx={{ height: 40 }}
      size="small"
      variant="outlined"
      placeholder={placeholder}
      value={value}
      onChange={(e) => onChange(e.target.value)}
      InputProps={{
        startAdornment: (
          <InputAdornment position="start">
            <SearchRounded sx={{ color: 'neutral.main' }} />
          </InputAdornment>
        ),
      }}
    />
  );
}
